import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'underscore';

@Pipe({
  name: 'orderStatsBy',
    pure:false
})

/*
* entra un array de arrays tipo [[{key:valor,kew2:valor2},{key:valor,kew2:valor2}],[{key:valor,kew2:valor2},{key:valor,kew2:valor2}],[{key:valor,kew2:valor2},{key:valor,kew2:valor2}]]
* sale un array de objetos para permitir el sort tipo:
* [
* {key:value(la key por la cual se quiere hacer el sort),data:[(array de entrada)]},
* ...
* ]
*
*
* */
export class OrderStatsByPipe implements PipeTransform {

  transform(data: Array<any>, label?: any): any {
      let out={};
      let contain=[];
      for(let col of data){
              for(let elem of col){
                  if(elem.label==label){
                      out[elem.label]=elem.value;
                      out['data']=col;
                      contain.push(out);
                      out={};
                  }
              }
      }
      return contain;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/pipe/order-stats-by.pipe.ts